exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".step3a-134e214c,.step3b-6d778351{display:flex;margin:30px auto;max-width:500px}.step3a-134e214c div.col-6d1b4f85,.step3b-6d778351 div.col-6d1b4f85{margin:0 20px}.step3a-134e214c video,.step3b-6d778351 video{max-height:300px;max-width:169.01408px;box-shadow:2px 2px 4px rgba(0,0,0,0.1)}.spinner-4bc83106{display:block;margin:10px auto}.status-183e6b55{color:#2A2A2A;background:#f5f5f5;padding:10px 20px;margin:0 0 20px 0;text-align:center}.status-183e6b55 span{vertical-align:middle}a.helpIcon-44fb9179,a.helpIcon-44fb9179:focus,a.helpIcon-44fb9179:visited{color:#BDBDBD}a.helpIcon-44fb9179:hover,a.helpIcon-44fb9179:focus:hover,a.helpIcon-44fb9179:visited:hover{color:#424242}\n", ""]);

// Exports
exports.locals = {
	"step3a": "step3a-134e214c",
	"step3b": "step3b-6d778351",
	"col": "col-6d1b4f85",
	"spinner": "spinner-4bc83106",
	"status": "status-183e6b55",
	"helpIcon": "helpIcon-44fb9179"
};